import {
	BifrostBackendNestApi,
	BifrostBackendViaCdnApiV2
} from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";

const { Formats: timeBoxFormats, timebox: timeBox } = appConfig.timeBoxImpl;
const tenantId = appConfig.tenantId;

/*
	Combined endpoints:
	v2.
		1. monitoring
		2. price-rules
		3. global-versions
		4. shops
		5. global-versions
		6. upsale-rules
		7. salling holidays
 */

export default {
	async getCombinedDataApi(useApiCdnCaching) {
		// Holidays params
		const holidaysParams = (() => {
			if (!(appConfig.tenantConfig.isSGTenant === true && appConfig.getBusinessModelId() === appConfig.businessModelsEnum.bm2.id)) {
				// SG catering only. It might be better to use a separate FT for this
				return;
			}

			// we only need one week
			const numberOfDays = 6;
			const startDate = timeBox.now().format(timeBoxFormats.YYYY_MM_DD).exec();
			const endDate =	timeBox.now().add({ days: numberOfDays }).format(timeBoxFormats.YYYY_MM_DD).exec();

			return {
				startDate,
				endDate
			};
		})();

		const bifrostBackendApi = useApiCdnCaching
			? BifrostBackendViaCdnApiV2
			: BifrostBackendNestApi;

		const response = await bifrostBackendApi.get("/landingpagedata", {
			params: {
				tenantId,
				timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				...holidaysParams
			}
		});

		return response.data;
	}
};
